import './z_header';
import '../css/index.less';
import listimg from '../../libs/list_img/list_img';
import banner from '../../libs/banner/banner';

// banner
if($('body').width()<768){
    banner.render({ bannerScale: 4/3 });
}else{
    banner.render({ bannerWidth: 1920, bannerHeight: 650 });
}

// 图片列表
listimg.render({
    colCount: 4,
});



// 新闻轮播
layui.use(['carousel'], function () {
    const carousel = layui.carousel;
    // 新闻banner
    carousel.render({
        elem: '#index-news-banner',
        width: '100%', //设置容器宽度
        height: '100%', // 高度
        anim: 'fade', // 显示方式
        arrow: 'none', //始终显示箭头
        indicator: 'inside', // 指示器位置
    });
});
